import {
    BundledProduct,
    Contract,
    Identification,
    isBalloonLeasing,
    ProductTypeEN,
    RequestCategory,
} from 'cpfr-common';
import React from 'react';
import {
    AuthorizationDebitForm,
    DeadlineForm,
    DeathForm,
    DocumentsForm,
    LossForm,
    OtherForm,
    RequestContractTransferForm,
    TenantChangeRequestForm,
    ChangeDurationMileageForm,
    VehicleClaimForm,
} from './category-views';
import { AuthorizationLeaveCountryForm } from './category-views/authorization-leave-country';
import { RegistrationCertificateDuplicateFormWithHandlers } from './category-views/registration-certificate-duplicate/RegistrationCertificateDuplicateFormWithHandlers';

export type CategoryViewProps = {
    category: RequestCategory;
    productTypeEn?: ProductTypeEN;
    productType?: string;
    identification?: Identification;
    isSMECustomer?: boolean;
    contractsSelected?: Contract[];
    defaultType: string;
    bundledProducts?: BundledProduct[];
};

export const CategoryView: React.FC<CategoryViewProps> = ({
    contractsSelected,
    category,
    productTypeEn,
    productType,
    identification,
    isSMECustomer,
    defaultType,
    bundledProducts,
}) => {
    const isAnyContractLeasingSocial = Boolean(contractsSelected?.some((contract) => contract.isLeasingSocial));
    const isAnyContractBalloonLeasing = Boolean(
        contractsSelected?.some((contract) => isBalloonLeasing(contract.productType)),
    );
    switch (category) {
        case 'AUTHORIZATION_DEBIT':
            return <AuthorizationDebitForm identification={identification} />;
        case 'DEADLINE':
            return (
                <DeadlineForm
                    isLeasingSocial={isAnyContractLeasingSocial}
                    isBalloonLeasing={isAnyContractBalloonLeasing}
                />
            );
        case 'VEHICLE_CLAIM':
            return (
                <VehicleClaimForm
                    productTypeEn={productTypeEn}
                    productType={productType}
                    bundledProducts={bundledProducts}
                />
            );
        case 'DEATH':
            return <DeathForm />;
        case 'LOSS':
            return <LossForm isLeasingSocial={isAnyContractLeasingSocial} />;
        case 'REQUEST_CONTRACT_TRANSFER':
            return <RequestContractTransferForm />;
        case 'AUTHORIZATION_LEAVE_COUNTRY':
            return <AuthorizationLeaveCountryForm />;
        case 'DOCUMENTS':
            return (
                <DocumentsForm
                    isSMECustomer={isSMECustomer}
                    contractsSelected={contractsSelected}
                    defaultType={defaultType}
                />
            );
        case 'REGISTRATION_CERTIFICATE_DUPLICATE':
            return <RegistrationCertificateDuplicateFormWithHandlers />;
        case 'TENANT':
            return <TenantChangeRequestForm />;
        case 'CHANGE_DURATION_MILEAGE':
            return <ChangeDurationMileageForm productTypeEn={productTypeEn} productType={productType} />;
        case 'OTHER':
            return <OtherForm />;
        default:
            return null;
    }
};
